<template>
  <div class="pa-4">
    <h1 >会員登録用のメールを送信しました</h1>
    <span style="color: red; font-size: 1.8em; font-weight: bold;">
      迷惑メールに入ってしまう可能性がございますので、5分以内に届かなかった場合は、チャットからお問い合わせくださいませ。<br />
    </span>
  </div>
</template>
<script>
export default {
  mounted() {
    console.log(this.auth.currentUser)
  }
}
</script>